import { Box } from '@landr/maestro';
import styled from 'styled-components';

const PreviewWrapper = styled(Box)`
    position: relative;
`;

export default PreviewWrapper;
